import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as DownArrow } from './img/diagram-arrow.svg';
import './FigureOutWhatYouWant.css';

export default class FigureOutWhatYouWant extends Component {
  static propTypes = {
    lines: PropTypes.array,
  }

  render() {
    const { lines } = this.props;
    const header = lines[0];
    const phrases = lines[1].split(',');

    return (
      <section className="figure-out-what-you-want">
        <h3>{header}</h3>
        <DownArrow className="down-arrow" />
        {phrases.map((phrase, i) =>
          <p key={i}>{phrase}</p>
        )}
      </section>
    );
  }
}
